import { InjectionToken } from '@angular/core';

import { Configuration } from './configuration.interface';

export const CONFIGURATION = new InjectionToken<Configuration>(
  'LBL App Util languages configuration',
);
